export const TRANSLATIONS_ENDPOINT = (baseUrl: string) => `${baseUrl}/api/cms/translations?app=registration`
